import { useEffect, useState } from 'react';
import { AlertType } from '../hooks/useAlert';

interface AlertMessageProps {
    message: string;
    type?: AlertType;
    onClose?: () => void;
    displayTime?: number; 
}

export default function AlertMessage ({ message, type = 'success', onClose, displayTime = 0 }: AlertMessageProps) {
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {
        if (isVisible && displayTime > 0) {
            const timer = setTimeout(() => {
                setIsVisible(false);
            }, displayTime);

            return () => clearTimeout(timer);
        }
    }, [isVisible, displayTime]);

    if (!isVisible) return null;

    return (
        <div className={`alert alert-${type}`} role="alert">
            <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={handleClose}
            >
                <span aria-hidden="true">&times;</span>
            </button>
            {message}
        </div>
    );
};